import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SubscribeIcon } from '../../../../assets/icons/subscriptions/subscribe.svg';
import AppButton from '../app-button/AppButton';
import { mergeSubscriptionButtonSx } from './subscriptionIconOnlyButtonSx';

type AppButtonProps = React.ComponentProps<typeof AppButton>;

export interface ISubscribeButtonProps
  extends Omit<AppButtonProps, 'children' | 'variant' | 'icon' | 'startIcon'> {
  /** Defaults to `common.subscribe` (private CTA may use `common.requestSubscription`). */
  labelKey?: string;
  /** List rows on mobile: icon only, no label. */
  iconOnly?: boolean;
}

export function SubscribeButton(props: ISubscribeButtonProps) {
  const {
    labelKey = 'common.subscribe',
    loading,
    iconOnly,
    sx,
    ...rest
  } = props;
  const { t } = useTranslation();
  const label = t(labelKey);

  return (
    <AppButton
      {...rest}
      sx={mergeSubscriptionButtonSx(iconOnly, sx)}
      loading={loading}
      variant="contained"
      icon={<SubscribeIcon />}
      aria-label={iconOnly ? label : undefined}>
      {iconOnly ? null : label}
    </AppButton>
  );
}
